import React, { useState } from "react";
import {
  Form,
  Input,
  InputNumber,
  Popconfirm,
  Select,
  Table,
  Button,
  Image,
  Space,
  Row,
  Col,
  Tooltip,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import DeviceLogStore from "../store/DeviceLogStore";
import ListTable from "./ListTable";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";

class DeviceLogList extends React.Component {
  constructor(props, context) {
    super(props);

    this.handleTableChange = this.handleTableChange.bind(this);
    this.deviceLogStore = new DeviceLogStore();

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      imei: "",
      loadData: 0,
      openDeleteModal: false,
      deleteData: {},
      editData: {},
    };

    this.columns = [
      {
        // title: "Modified By",
        title: context.translate("_MODIFIEDBY_"),
        dataIndex: "username",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Company Name",
        title: context.translate("_COMPANY_NAME_"),
        dataIndex: "companyName",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Vehicle No",
        title: context.translate("_VEHICLE_NO_"),
        dataIndex: "vehicleNo",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "IMEI",
        title: context.translate("_FLEET_DASHBORD_SETTING_IMEI_"),
        dataIndex: "imei",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Field Name",
        title: context.translate("_FIELD_NAME_"),
        dataIndex: "field",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Before",
        title: context.translate("_BEFORE_"),
        dataIndex: "before",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "After",
        title: context.translate("_AFTER_"),
        dataIndex: "after",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Date",
        title: context.translate("_FLEET_REPORTS_DATE_"),
        dataIndex: "entryDate",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Status",
        title: context.translate("_FLEET_DASHBORD_DROWGEO_ALERTSTATUS_"),
        dataIndex: "status",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
      },
    ];
  }

  async componentDidMount() {
    await this.deviceLogStore.loadData({ offset: 0, limit: 50 });
    this.setState({ pageSize: 50 });
  }
  async componentDidUpdate(prevProps, prevState) {
    if (
      Number(this.props.getUserData().isadmin) === 1 &&
      Number(this.props.getUserData().isadmin) === 0
    ) {
      this.props.navigate("/login");
    }
  }

  async handleTableChange(pagination, filters, sorter) {
    console.log(pagination, "pagi");
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.handleSearch();
  }

  async handleSearch() {
    this.setState({ loading: true });
    await this.deviceLogStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      searchField: this.state.searchField,
    });
    console.log(this.state.imei);
    await this.setState({ loadData: 1 });
  }

  async inputSearchButton() {
    await this.deviceLogStore.loadData({
      offset: 0,
      limit: 50,
      searchField: this.state.searchField,
    });

    await this.setState({ loadList: 1, currentPage: 1 });
  }

  searchInput = async (e) => {
    const value = e.target.value;
    console.log(value);
    await this.setState({ searchField: value });
    if (value.length > 3) {
      await this.deviceLogStore.loadData({
        offset: 0,
        limit: this.state.pageSize,
        searchField: value,
      });
      await this.setState({ loadList: 1, companyLoading: false });
    } else if (value.length === 0) {
      await this.deviceLogStore.loadData({
        offset: 0,
        limit: this.state.pageSize,
        searchField: value,
      });
      await this.setState({ currentPage: 1 });
    }
  };
  refreshList = async () => {
    this.setState({ loading: true });
    await this.deviceLogStore.loadData({
      offset: 0,
      limit: 50,
    });
    this.setState({ loading: false, currentPage: 1 });
  };
  render() {
    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Space>
              <Input
                className="searchInput"
                style={{
                  width: 200,
                  borderRadius: "25px",
                }}
                // placeholder="Search IMEI"
                placeholder={this.context.translate("_SEARCH_IMEI_")}
                onChange={async (e) => {
                  await this.setState({ searchField: e.target.value });
                  console.log(e.target.value);
                  await this.searchInput(e);
                }}
              />
            </Space>
            <Col
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
              span={8}
            >
              <Tooltip
                title={this.context.translate("_REFRESH_")}
                placement="bottom"
              >
                <Image
                  style={{
                    height: 18,
                    marginInlineEnd: "20px",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                  src={refreshIcon}
                  onClick={() => this.refreshList()}
                ></Image>
              </Tooltip>
            </Col>
            {/* <Col span={16}></Col>
            <Col span={8}>
              <Space
                style={{
                  float:
                    this.context.locale.direction == "ltr" ? "right" : "left",
                }}
              ></Space>
            </Col> */}
          </Row>

          <ListTable
            currentPage={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.deviceLogStore?.total}
            columns={this.columns}
            dataSource={this.deviceLogStore?.deviceLog}
            loading={this.deviceLogStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>
      </>
    );
  }
}
DeviceLogList.contextType = StoreContext;
export default observer(DeviceLogList);
